import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import AboutUs from "layouts/pages/landing-pages/about-us";
import MKTypography from "components/MKTypography";
import logoCT from "assets/images/collab-rect-wos.png";


const date = new Date().getFullYear();

export default {
  brand: {
    name: "COLLAB",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/ZippyOps",
    },
    {
      icon: <FacebookIcon />,
      link: "https://facebook.com/zippyops",
    },
    {
      icon: <InstagramIcon />,
      link: "https://instagram.com/zippyops",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://youtube.com/channel/UCZh2aijMM-h6ztRo36m3CiQ",
    },
    {
      icon: <LinkedInIcon />,
      link: "https://linkedin.com/in/zippyops",
    },
    {
      icon: <TelegramIcon />,
      link: "https://t.me/ZippyOPS",
    },
  ],
  menus: [
    {
      name: "Links",
      items: [
        { name: "about us", href: "https://www.zippyops.com/about-us" },
        { name: "blog", href: "https://www.zippyops.com/blog/general" },
        { name: "contact us", href: "https://www.zippyops.com/contact-us" },
        { name: "LabAsService", href: "https://www.labasservice.com/" },
      ],
    },
    {
      name: "US-Address",
      items: [
        { name: "8 The Green,",
        description:"8 The Green,",
        },
        { name: "Ste A ‌Dover,",
        description:"Ste A ‌Dover,",
        },
         { name: "DE 19901",
        description:"DE 19901",
        },
      ],
    },
    {
      name: "Address",
      items: [
        {
          name: "No. 209/210, 1st Floor J Nagar, Panaiyur Kuppam Main Road, Panaiyur, Chennai, Tamil Nadu 600119",
          description:
            "No. 209/210, 1st Floor J Nagar, Panaiyur Kuppam Main Road, Panaiyur, Chennai, Tamil Nadu 600119",
        },
      ],
    },

    {
      name: "Contact",
      items: [
        {
          name: `hello@zippyops.com`,
        },
        {
          name: "Phone : +91-7010585768",
        },
        {
          name: "Phone : +91-8903067727",
        },
        {
          name: "Phone : (+1) 302 492 2530",
        },
      ],
    },
  ],
  description: (
    <MKTypography sx={{ color:"#FFFFFF" }}>
      ZippyOPS Consulting Services LLP
    </MKTypography>
  ),
  copyright: (
    <MKTypography variant="button" fontWeight="regular" sx={{ color:"#FFFFFF" }}>
      All rights reserved. Copyright &copy; {date} COLLAB by{" "}
      <MKTypography
        component="a"
        href="https://www.zippyops.com/"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
        sx={{ color:"#FFFFFF" }}
      >
        ZippyOPS Consulting Services LLP
      </MKTypography>
      .
    </MKTypography>
  ),
};
